define('view/disclosure/disclosure.form.tab.page.view',['require','exports','module','underscore','blockit','formkit/formkit','backbone.radio','fukit','view/disclosure/action.items.component','view/disclosure/persistent.left.sidebar','view/disclosure/persistent.left.sidebar.modals','fukit','behavior/navigate.on.tab.press.behavior'],function(require, exports, module) {
  // prettier-ignore
  var _                     = require('underscore'),
      BlocKit               = require('blockit'),
      FormKit               = require('formkit/formkit'),
      Radio                 = require('backbone.radio'),
      ROLES                 = require('fukit').Roles,
      ActionItemsComponent  = require('view/disclosure/action.items.component'),

  //persistent left sidebar and modals
      PersistentLeftSidebar       = require('view/disclosure/persistent.left.sidebar'),
      PersistentLeftSidebarModals = require('view/disclosure/persistent.left.sidebar.modals'),

  //behaviors
      AuthorizationBehavior      = require('fukit').AuthorizationBehavior,
      NavigateOnTabPressBehavior = require('behavior/navigate.on.tab.press.behavior');

  var DisclosureFormPageLayout = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: PersistentLeftSidebarModals,
      //Parent two column layout
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,
        pageHeader: {
          headerText: 'COI Disclosures',
          breadcrumbs: [
            {
              text: 'COI Disclosures',
              route: 'disclosure:list',
              behaviors: {
                AuthorizationBehavior: {
                  // for COI Admin
                  visibleOnlyWhen: [
                    {
                      roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
                    },
                  ],
                  behaviorClass: AuthorizationBehavior,
                },
              },
            },

            {
              // Note: text should have a binding to a field disclosureOwnerFullName
              text: 'Disclosure Owner',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      formatter: function() {
                        var disclosureDetailModel = Radio.request('AppKit.resourceService', 'resource', 'disclosure');
                        var productNewCoiUiValue = false;

                        if (!localStorage.getItem('productNewCoiUi')) {
                          var coiModel;

                          const enabledProductCollection = Radio.request(
                            'AppKit.resourceService',
                            'resource',
                            'enabledProductCollection'
                          );

                          if (!_.isUndefined(enabledProductCollection)) {
                            coiModel = enabledProductCollection.findWhere({ name: 'COI', active: true });
                            const dataModel = coiModel.collection.models;
                            const filteredDataArray = dataModel.filter(function(item) {
                              return item.attributes.name === 'COI' && item.attributes.active === true;
                            });
                            productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
                          }
                        }

                        var displayName = '';

                        if (disclosureDetailModel) {
                          if (productNewCoiUiValue) {
                            const disclosureId = disclosureDetailModel.get('id');
                            localStorage.setItem('productNewCoiUiValue', productNewCoiUiValue.toString());
                            const ROUTE = '/disclosure/form/';
                            const DISCLOSEE_PARAMETER = '/disclosee';
                            location.assign(
                              location.origin + '/coi-react' + ROUTE + disclosureId + DISCLOSEE_PARAMETER
                            );
                          }

                          var fullName = disclosureDetailModel.get('disclosureOwnerFullName');

                          if (fullName && fullName.trim().length > 0) {
                            displayName = displayName + fullName;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
          ],
          //Action buttons are created from workflow options available to the user at any given step in the workflow
          //Since the tabbed views have the same actions component definition, we've moved those into a common module
          actionsFromCollection: ActionItemsComponent,
        },
        contentColumn: {
          components: [
            {
              type: BlocKit.TabsContainerView,
              openTabIndex: 0,
              behaviors: {
                navigateOnTabPress: {
                  routeParams: { primaryId: '@state.primaryId' },
                  behaviorClass: NavigateOnTabPressBehavior,
                },
              },
              components: [
                {
                  tabMenuItem: {
                    text: 'COI Disclosure Answers',
                    horizontalNavMode: true,
                  },
                  tabContent: {
                    type: BlocKit.AttachedComponentsContainerView,
                    components: [
                      {
                        type: BlocKit.ContentActionsHeaderView,
                        header: {
                          text: 'COI Disclosure',
                        },
                      },

                      //Inner two column layout for the form.  Maybe we should create a custom two column layout view instead so we don't
                      //have to hide the pageHeader?
                      {
                        type: BlocKit.TwoColumnLeftRailLayoutView,
                        pageHeader: {
                          visible: false,
                        },

                        //Main form content
                        contentColumn: {
                          components: [
                            //"Previous"/"Next" section navigation for the form
                            //TODO: Check with UX and see if we should hide this part if only one section is available
                            {
                              type: BlocKit.ContentActionsHeaderView,
                              attached: true,
                              color: 'none',
                              attributes: {
                                style: 'margin-top: 2em;',
                              },
                              header: {
                                model: '@resources.templateType',
                                behaviors: {
                                  BindTextToActiveSectionTitleBehavior: {
                                    form: '@this.form',
                                    optionName: 'text',
                                    bindValueToSectionAttribute: 'text',
                                    behaviorClass: FormKit.BindOptionToActiveSectionChangeBehavior,
                                  },
                                },
                              },
                              actions: {
                                components: [
                                  {
                                    text: 'Previous',
                                    behaviors: {
                                      GoToPreviousSectionBehavior: {
                                        behaviorClass: FormKit.GoToPreviousSectionBehavior,
                                        form: '@this.form',
                                      },
                                    },
                                  },
                                  {
                                    text: 'Next',
                                    behaviors: {
                                      GoToNextSectionBehavior: {
                                        behaviorClass: FormKit.GoToNextSectionBehavior,
                                        form: '@this.form',
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                            //Main body of the form
                            {
                              type: FormKit.Block.AnswerFormObjectCollectionView,
                              form: '@this.form',
                              childViewOptions: {
                                childViewOptions: {
                                  top: function() {
                                    return {
                                      actions: {},
                                    };
                                  },
                                },
                              },
                              behaviors: {
                                BindAndFormatOptionValuesBehavior: {
                                  optionValues: {
                                    readonly: {
                                      modelAttribute: 'canEdit',
                                      model: '@resources.formPermissionModel',
                                      formatter: BlocKit.Formatter.invert(),
                                    },
                                  },
                                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                                },
                              },
                            },
                          ],
                        },
                        //Form section navigation
                        railColumn: {
                          components: [
                            {
                              type: FormKit.Block.AnswerSectionMenuView,
                              attributes: {
                                style: 'margin-top: 2em;',
                              },
                              form: '@this.form',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  tabMenuItem: {
                    text: 'Documents',
                    horizontalNavMode: true,
                    routeName: 'disclosure:documents',
                    attributes: {
                      style: 'cursor: pointer;',
                    },
                  },
                },
                {
                  tabMenuItem: {
                    text: 'Process History',
                    horizontalNavMode: true,
                    routeName: 'disclosure:history',
                    attributes: {
                      style: 'cursor: pointer;',
                    },
                  },
                },
              ],
            },
          ],
        },
        //Persistent left column disclosure information, workflow tasks, etc.
        railColumn: PersistentLeftSidebar,
      },
    },
  });

  module.exports = DisclosureFormPageLayout;
});

